import { CMSApiBase, createCmsUrl, getResponseCMS } from './base';
import { fetcherCMS } from '@/modules/api';
import { getCMSLocale } from '@/modules/cms';

export interface AboutUsApi extends CMSApiBase {
  titleH1: string;
  text: string;
  bottomText: string;
}

export const getAboutUsCMSUrl = (lang: string) =>
  createCmsUrl({
    path: 'about-us-v-2',
    queryData: {
      ...getCMSLocale(lang),
      populate: 'deep',
    },
  });

export const fetchAboutUsCMS = async (lang: string) => {
  const response = await fetcherCMS<AboutUsApi>(getAboutUsCMSUrl(lang));
  return { data: response };
};
